import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/site/PublicLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Work from "@/pages/Work";
import Enquire from "@/pages/Enquire";
import EnquiryConfirmation from "@/pages/EnquiryConfirmation";
import QuoteView from "@/pages/QuoteView";
import { Agency, Faq, Privacy, NotFound, About } from "@/pages/StaticPages";
import Apply from "@/pages/Apply";
import ServiceLanding from "@/pages/ServiceLanding";
import ApplicationsAdmin from "@/pages/admin/ApplicationsAdmin";
import PagesAdmin from "@/pages/admin/PagesAdmin";
import Login from "@/pages/admin/Login";
import AuthCallback from "@/pages/admin/AuthCallback";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Enquiries from "@/pages/admin/Enquiries";
import EnquiryDetail from "@/pages/admin/EnquiryDetail";
import Projects from "@/pages/admin/Projects";
import ProjectDetail from "@/pages/admin/ProjectDetail";
import ServicesAdmin from "@/pages/admin/ServicesAdmin";
import PortfolioAdmin from "@/pages/admin/PortfolioAdmin";
import FaqsAdmin from "@/pages/admin/FaqsAdmin";
import ContentAdmin from "@/pages/admin/ContentAdmin";
import SeoAdmin from "@/pages/admin/SeoAdmin";
import EmailsAdmin from "@/pages/admin/EmailsAdmin";
import TeamAdmin from "@/pages/admin/TeamAdmin";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceLanding />} />
        <Route path="/about" element={<About />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/work" element={<Work />} />
        <Route path="/work/:slug" element={<Navigate to="/work" replace />} />
        <Route path="/agency" element={<Agency />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/enquire" element={<Enquire />} />
        <Route path="/enquire/confirmation/:reference" element={<EnquiryConfirmation />} />
        <Route path="/quote/:token" element={<QuoteView />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Overview />} />
        <Route path="enquiries" element={<Enquiries />} />
        <Route path="enquiries/:id" element={<EnquiryDetail />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:id" element={<ProjectDetail />} />
        <Route path="applications" element={<ApplicationsAdmin />} />
        <Route path="pages" element={<PagesAdmin />} />
        <Route path="services" element={<ServicesAdmin />} />
        <Route path="portfolio" element={<PortfolioAdmin />} />
        <Route path="faqs" element={<FaqsAdmin />} />
        <Route path="content" element={<ContentAdmin />} />
        <Route path="seo" element={<SeoAdmin />} />
        <Route path="emails" element={<EmailsAdmin />} />
        <Route path="team" element={<TeamAdmin />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster theme="dark" position="bottom-right" toastOptions={{ className: "rounded-none border-[#27272A] bg-[#121212]" }} />
      </AuthProvider>
    </BrowserRouter>
  );
}
